import img0 from "./Assets/0.png";
import img1 from "./Assets/1.png";
import img2 from "./Assets/2.png";
import img3 from "./Assets/3.png";
import img4 from "./Assets/4.png";
import img5 from "./Assets/5.png";
import img6 from "./Assets/6.png";
import img7 from "./Assets/7.png";
import img8 from "./Assets/8.png";
import img9 from "./Assets/9.png";
import img10 from "./Assets/10.png";
import img11 from "./Assets/11.png";
import img12 from "./Assets/12.png";
import img13 from "./Assets/13.png";
import logo from "./Assets/ff.png";

export default class FarmyardFortunesSpinNWinConfig {
    constructor() {
        // Set up the symbol imgs & Logo
        // Make sure to match with imports above
        this.symbolImgs = [img0, img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13];
        this.logo = logo;

        //Game Name
        this.name = "Farmyard Fortunes Spin N Win";

        //General Config
        this.reels = 5;
        this.symbolPerReel = 3;
        this.cascade = false;

        //This is used to invert the symbol IDs (because Aris). Input the highest symbol ID possible in the game.
        //Have left this to be a manual input as sometimes it can work slightly differently depending on game
        this.highestSymId = 13;

        //Ask CROW for the maths object
        this.maths = this.getMaths();
    }

    getMaths() {
        //paste what crow gives you here!
        return {
            94: {
                reductionWeight1M: 20741,
            },
            96: {
                weights: {
                    baseGame: [200, 40, 45],
                    freeSpins: {
                        f: [9, 11],
                    },
                },
                reelSets: {
                    0: [
                        [
                            1, 7, 4, 10, 1, 0, 5, 2, 0, 7, 3, 6, 1, 8, 0, 5, 6, 7, 4, 6, 8, 0, 4, 2, 5, 3, 11, 2, 3, 8,
                            13, 13, 2, 4, 1, 0, 9, 3, 1, 7, 5, 2, 8, 9, 3, 6, 10, 8, 0, 10, 1, 7, 4, 6, 3, 10, 4, 9, 5,
                            3, 11, 2, 3, 1, 13, 9,
                        ],
                        [
                            13, 3, 5, 11, 3, 8, 2, 3, 7, 2, 6, 1, 0, 9, 4, 1, 7, 5, 4, 0, 10, 1, 6, 2, 10, 4, 8, 3, 0,
                            6, 13, 13, 7, 6, 2, 3, 11, 5, 3, 8, 2, 3, 7, 10, 6, 1, 0, 9, 4, 1, 7, 5, 9, 0, 10, 1, 9, 2,
                            10, 4, 8, 6, 0, 9, 2, 6,
                        ],
                        [
                            10, 6, 0, 4, 5, 0, 6, 4, 5, 7, 3, 9, 2, 3, 1, 4, 5, 7, 1, 5, 10, 2, 0, 8, 1, 3, 11, 2, 7, 8,
                            13, 13, 6, 9, 1, 6, 0, 4, 10, 0, 6, 4, 7, 8, 3, 9, 2, 3, 10, 4, 5, 7, 1, 13, 10, 2, 0, 8, 1,
                            3, 11, 8, 4, 6, 13, 9,
                        ],
                        [
                            13, 8, 4, 1, 5, 3, 9, 7, 1, 11, 6, 3, 10, 2, 8, 1, 10, 11, 9, 5, 6, 0, 4, 3, 5, 0, 9, 11, 0,
                            7, 13, 13, 8, 10, 2, 8, 4, 1, 10, 3, 9, 7, 1, 2, 6, 3, 10, 2, 8, 1, 7, 2, 9, 13, 6, 0, 4,
                            11, 5, 0, 7, 11, 0, 7, 2, 9, 8, 10,
                        ],
                        [
                            11, 2, 1, 8, 0, 5, 11, 10, 0, 7, 3, 8, 7, 2, 6, 4, 3, 9, 2, 11, 0, 8, 3, 6, 10, 9, 5, 3, 7,
                            5, 13, 13, 2, 5, 6, 1, 10, 4, 11, 1, 4, 9, 11, 2, 1, 8, 0, 5, 11, 10, 0, 7, 3, 13, 7, 2, 6,
                            4, 3, 9, 2, 11, 0, 5, 13, 8, 10, 9, 5, 3, 7, 6, 3, 9, 2, 5, 11, 1, 6,
                        ],
                    ],
                    1: [
                        [
                            1, 0, 9, 10, 1, 7, 5, 2, 8, 0, 3, 6, 1, 8, 0, 10, 6, 7, 4, 6, 8, 7, 4, 8, 5, 3, 11, 2, 5, 7,
                            0, 2, 3, 4, 1, 0, 9, 3, 1, 7, 5, 2, 8, 12, 9, 6, 1, 8, 0, 6, 1, 7, 4, 6, 3, 10, 4, 9, 5, 3,
                            11, 2, 3, 10, 1, 0, 5, 9, 10, 2, 7,
                        ],
                        [
                            2, 3, 11, 5, 3, 8, 2, 3, 7, 2, 6, 1, 10, 8, 4, 1, 7, 5, 12, 0, 10, 1, 4, 2, 10, 4, 8, 7, 0,
                            6, 4, 5, 7, 6, 2, 3, 11, 5, 3, 8, 2, 3, 7, 12, 6, 1, 0, 9, 4, 1, 7, 5, 9, 0, 10, 1, 9, 2,
                            10, 4, 8, 6, 0, 3, 4, 9, 7, 6, 9, 5, 8,
                        ],
                        [
                            1, 6, 0, 4, 12, 0, 6, 4, 7, 5, 3, 9, 2, 3, 10, 4, 5, 7, 1, 5, 10, 2, 0, 8, 1, 3, 11, 2, 4,
                            8, 7, 3, 6, 9, 1, 6, 0, 12, 10, 0, 6, 4, 7, 12, 3, 9, 2, 3, 10, 4, 5, 11, 1, 5, 10, 2, 0, 8,
                            1, 3, 11, 8, 4, 2, 7, 8, 6, 9, 7, 5, 9,
                        ],
                        [
                            2, 8, 4, 1, 12, 3, 9, 7, 4, 2, 6, 3, 10, 2, 8, 1, 10, 2, 9, 11, 6, 0, 4, 11, 5, 12, 9, 11,
                            0, 7, 6, 5, 8, 10, 2, 8, 12, 1, 10, 3, 9, 7, 1, 12, 6, 3, 10, 2, 8, 1, 7, 2, 9, 5, 6, 0, 4,
                            11, 5, 0, 7, 11, 0, 9, 6, 4, 8, 10, 6, 5, 3,
                        ],
                        [
                            11, 2, 1, 8, 0, 5, 11, 10, 0, 7, 3, 8, 7, 2, 12, 4, 3, 9, 2, 11, 0, 8, 3, 6, 10, 12, 5, 3,
                            7, 5, 9, 0, 2, 5, 6, 1, 10, 4, 11, 1, 4, 9, 11, 2, 1, 8, 0, 5, 11, 10, 0, 7, 3, 8, 7, 2, 6,
                            4, 3, 9, 2, 11, 0, 8, 9, 5, 10, 12, 5, 3, 7, 6, 3, 9, 2, 5, 6, 1, 10, 4, 11, 1, 4, 9,
                        ],
                    ],
                    2: [
                        [
                            1, 0, 9, 10, 1, 7, 5, 2, 8, 0, 3, 6, 1, 8, 0, 10, 6, 7, 4, 6, 8, 7, 4, 8, 5, 3, 11, 2, 12,
                            7, 0, 2, 3, 4, 1, 0, 12, 3, 1, 7, 5, 2, 8, 12, 9, 6, 1, 8, 0, 6, 1, 7, 4, 6, 3, 10, 4, 9, 5,
                            3, 11, 2, 3, 10, 1, 0, 5, 9, 10, 2, 7,
                        ],
                        [
                            2, 3, 11, 5, 3, 8, 2, 12, 7, 2, 6, 1, 0, 8, 4, 1, 7, 5, 12, 0, 10, 1, 4, 2, 10, 4, 8, 12, 0,
                            6, 4, 5, 7, 6, 2, 3, 11, 5, 3, 8, 2, 3, 7, 12, 6, 1, 0, 9, 4, 1, 7, 5, 9, 0, 10, 1, 9, 2,
                            10, 4, 8, 6, 0, 3, 4, 9, 7, 6, 9, 5, 8,
                        ],
                        [
                            1, 6, 0, 4, 12, 0, 6, 4, 7, 11, 3, 9, 2, 3, 10, 4, 5, 7, 1, 5, 10, 2, 0, 8, 1, 3, 11, 2, 4,
                            8, 7, 3, 6, 9, 1, 6, 0, 12, 10, 0, 6, 4, 7, 12, 3, 9, 2, 3, 10, 4, 5, 11, 1, 5, 10, 2, 0, 8,
                            1, 3, 11, 8, 4, 2, 7, 8, 6, 9, 7, 5, 9,
                        ],
                        [
                            2, 8, 4, 1, 12, 3, 9, 7, 11, 2, 6, 3, 10, 2, 8, 1, 10, 2, 9, 5, 6, 0, 4, 11, 5, 0, 9, 11, 0,
                            7, 6, 5, 8, 10, 2, 8, 4, 1, 10, 3, 9, 7, 1, 12, 6, 3, 10, 2, 8, 1, 7, 2, 9, 5, 6, 0, 4, 11,
                            5, 0, 7, 11, 0, 9, 6, 4, 8, 10, 6, 5, 3,
                        ],
                        [
                            11, 2, 1, 8, 0, 5, 11, 10, 0, 7, 3, 8, 7, 2, 6, 4, 3, 9, 2, 11, 0, 8, 3, 6, 10, 1, 5, 3, 7,
                            5, 9, 0, 2, 5, 6, 1, 10, 4, 11, 1, 4, 9, 11, 2, 1, 8, 0, 5, 11, 10, 0, 7, 3, 8, 7, 2, 6, 4,
                            3, 9, 2, 11, 0, 8, 9, 5, 10, 12, 5, 3, 7, 6, 3, 9, 2, 5, 6, 1, 10, 4, 11, 1, 4, 9,
                        ],
                    ],
                    f_0: [
                        [
                            1, 9, 0, 10, 1, 7, 11, 2, 10, 12, 3, 2, 9, 4, 0, 10, 6, 5, 4, 11, 2, 0, 4, 8, 5, 10, 11, 2,
                            8, 7, 0, 5, 3, 4, 1, 0, 9, 3, 1, 7, 5, 2, 8, 12, 9, 6, 1, 8, 0, 6, 1, 7, 4, 6, 3, 10, 4, 9,
                            5, 3, 11, 2, 4,
                        ],
                        [
                            2, 3, 11, 5, 3, 8, 2, 10, 7, 9, 6, 1, 0, 7, 4, 1, 7, 5, 12, 0, 10, 1, 11, 9, 10, 4, 8, 11,
                            0, 2, 7, 4, 0, 6, 2, 3, 11, 5, 3, 8, 2, 3, 1, 12, 6, 1, 0, 9, 4, 1, 7, 5, 9, 0, 10, 1, 9, 2,
                            10, 4, 8, 6, 4,
                        ],
                        [
                            1, 6, 0, 4, 12, 0, 6, 4, 7, 11, 3, 12, 2, 0, 6, 4, 5, 7, 1, 8, 3, 2, 0, 8, 1, 3, 11, 2, 4,
                            8, 6, 5, 7, 9, 1, 6, 0, 4, 5, 0, 6, 4, 7, 12, 3, 9, 2, 3, 10, 4, 5, 11, 1, 5, 10, 2, 0, 8,
                            1, 3, 11, 2, 5,
                        ],
                        [
                            2, 8, 4, 1, 12, 3, 9, 7, 11, 2, 6, 12, 10, 0, 8, 1, 10, 2, 9, 3, 6, 0, 4, 11, 5, 0, 9, 11,
                            0, 7, 1, 3, 8, 10, 2, 8, 4, 1, 10, 3, 9, 7, 1, 12, 6, 3, 10, 2, 8, 1, 7, 2, 9, 5, 6, 0, 4,
                            11, 5, 0, 7, 1, 5,
                        ],
                        [
                            11, 2, 1, 8, 0, 5, 11, 10, 0, 7, 12, 8, 7, 1, 6, 4, 3, 9, 2, 4, 0, 8, 3, 6, 10, 12, 5, 3, 7,
                            5, 6, 9, 2, 5, 6, 1, 10, 4, 9, 1, 4, 9, 11, 2, 1, 8, 0, 5, 11, 10, 0, 7, 3, 8, 7, 2, 6, 4,
                            3, 9, 2, 1, 0, 7, 4, 5, 10, 12, 5, 3,
                        ],
                    ],
                    f_1: [
                        [
                            1, 9, 0, 10, 1, 7, 11, 2, 10, 4, 3, 2, 9, 13, 13, 10, 6, 5, 4, 11, 2, 0, 4, 8, 5, 10, 11, 2,
                            8, 7, 13, 13, 3, 4, 1, 0, 9, 3, 1, 7, 5, 2, 8, 5, 9, 6, 1, 8, 0, 6, 1, 7, 4, 6, 3, 10, 4, 9,
                            5, 3, 11, 2, 13,
                        ],
                        [
                            2, 3, 11, 5, 3, 8, 2, 10, 7, 9, 6, 1, 0, 13, 13, 1, 7, 5, 6, 4, 10, 1, 11, 9, 10, 4, 8, 11,
                            0, 2, 13, 13, 0, 6, 2, 3, 11, 5, 3, 8, 2, 3, 1, 5, 6, 1, 0, 9, 4, 1, 7, 5, 9, 0, 10, 1, 9,
                            2, 10, 4, 8, 6, 13,
                        ],
                        [
                            1, 6, 0, 4, 5, 0, 6, 4, 7, 11, 3, 5, 2, 13, 13, 4, 5, 7, 1, 6, 3, 2, 0, 8, 1, 3, 11, 2, 4,
                            8, 13, 13, 7, 9, 1, 6, 0, 4, 5, 0, 6, 4, 7, 6, 3, 9, 2, 3, 10, 4, 5, 11, 1, 5, 10, 2, 0, 8,
                            1, 3, 11, 2, 13,
                        ],
                        [
                            2, 8, 4, 1, 6, 3, 9, 7, 11, 2, 6, 3, 10, 13, 13, 1, 10, 2, 9, 8, 6, 0, 4, 11, 5, 0, 9, 11,
                            0, 7, 13, 13, 8, 10, 2, 8, 4, 1, 10, 3, 9, 7, 1, 8, 6, 3, 10, 2, 8, 1, 7, 2, 9, 5, 6, 0, 4,
                            11, 5, 0, 7, 1, 13,
                        ],
                        [
                            11, 2, 1, 8, 0, 5, 11, 10, 0, 7, 6, 8, 7, 13, 6, 4, 3, 9, 2, 4, 0, 8, 3, 6, 10, 8, 5, 3, 7,
                            5, 13, 13, 2, 5, 6, 1, 10, 4, 9, 1, 4, 9, 11, 2, 1, 8, 0, 5, 11, 10, 0, 7, 3, 8, 7, 2, 6, 4,
                            3, 9, 2, 1, 0, 13, 13, 5, 10,
                        ],
                    ],
                },
            },
        };
    }
}
